import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnable24HourShopifyProductSync = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enable24HourShopifyProductSync);
};
